import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import "./styles/About.css";

import { statsDetails } from "./data/stats";
import { NAV_CTA } from "./data/navbar/menu";
import {
  ABOUT_EYEBROW,
  ABOUT_TITLE,
  ABOUT_TITLE_EMPHASIS,
  ABOUT_SUBTITLE,
  ABOUT_STORY_LABEL,
  ABOUT_STORY_HEADING,
  ABOUT_STORY_PARA_1,
  ABOUT_STORY_PARA_2,
  ABOUT_STORY_PARA_3,
  ABOUT_STATS_LABEL,
  ABOUT_STATS_HEADING,
  ABOUT_FOUNDERS_LABEL,
  ABOUT_FOUNDERS_HEADING,
  ABOUT_CTA_HEADING,
} from "./data/i18n/about";
import {
  TEAM_MEMBER_1_DESCRIPTION,
  TEAM_MEMBER_1_NAME,
  TEAM_MEMBER_1_ROLE,
  TEAM_MEMBER_2_DESCRIPTION,
  TEAM_MEMBER_2_NAME,
  TEAM_MEMBER_2_ROLE,
} from "./data/i18n/team";

import Rajendra from "./assets/images/team/Rajendra.jpeg";
import Chandra from "./assets/images/team/Chandra.jpeg";

const founders = [
  {
    name: TEAM_MEMBER_1_NAME,
    role: TEAM_MEMBER_1_ROLE,
    description: TEAM_MEMBER_1_DESCRIPTION,
    image: Rajendra,
  },
  {
    name: TEAM_MEMBER_2_NAME,
    role: TEAM_MEMBER_2_ROLE,
    description: TEAM_MEMBER_2_DESCRIPTION,
    image: Chandra,
  },
];

const About = () => {
  const { t } = useTranslation();

  return (
    <>
      <AppBar />

      <section className="about-hero">
        <span className="about-eyebrow">
          <span className="about-eyebrow-dot" />
          {t(ABOUT_EYEBROW)}
        </span>
        <h1 className="about-hero-title">
          {t(ABOUT_TITLE)} <em>{t(ABOUT_TITLE_EMPHASIS)}</em>
        </h1>
        <p className="about-hero-subtitle">{t(ABOUT_SUBTITLE)}</p>
      </section>

      <section className="about-section about-story">
        <div className="about-label">{t(ABOUT_STORY_LABEL)}</div>
        <h2 className="about-heading">{t(ABOUT_STORY_HEADING)}</h2>
        <p>{t(ABOUT_STORY_PARA_1)}</p>
        <p>{t(ABOUT_STORY_PARA_2)}</p>
        <p>{t(ABOUT_STORY_PARA_3)}</p>
      </section>

      <section className="about-section about-stats">
        <div className="about-label">{t(ABOUT_STATS_LABEL)}</div>
        <h2 className="about-heading">{t(ABOUT_STATS_HEADING)}</h2>
        <div className="about-stats-row">
          {statsDetails.map((stat) => (
            <div className="about-stat" key={stat.detail}>
              <FontAwesomeIcon icon={stat.icon} className="about-stat-icon" />
              <div className="about-stat-number">{stat.number}</div>
              <div className="about-stat-label">{t(stat.detail)}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-section about-founders">
        <div className="about-label">{t(ABOUT_FOUNDERS_LABEL)}</div>
        <h2 className="about-heading">{t(ABOUT_FOUNDERS_HEADING)}</h2>
        <div className="about-founders-grid">
          {founders.map((founder) => (
            <div className="about-founder-card" key={founder.name}>
              <img
                className="about-founder-avatar"
                src={founder.image}
                alt={t(founder.name)}
              />
              <h3 className="about-founder-name">{t(founder.name)}</h3>
              <div className="about-founder-role">{t(founder.role)}</div>
              <div className="about-founder-desc">{t(founder.description)}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-cta">
        <h2 className="about-heading">{t(ABOUT_CTA_HEADING)}</h2>
        <a className="about-cta-btn" href="/#contact">
          {t(NAV_CTA)}
        </a>
      </section>

      <Footer />
    </>
  );
};

export default About;
